import { NgModule } from '@angular/core';
import { LibRecatIconComponent } from './lib-recategorisation-icon.component';

@NgModule({
  declarations: [LibRecatIconComponent],
  exports: [LibRecatIconComponent],
})
export class LibRecategorisationIconModule {}
